import { render } from "./info-svg.vue?vue&type=template&id=12d424da"
import script from "./info-svg.vue?vue&type=script&lang=js"
export * from "./info-svg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__